export const biologicalSexOptions = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "other", label: "Other" },
  { value: "preferNotToRespond", label: "Prefer Not to Respond" },
];

export const genderOptions = [
  { value: "man", label: "Man" },
  { value: "woman", label: "Woman" },
  { value: "genderFluid", label: "Gender Fluid" },
  { value: "transgender", label: "Transgender" },
  { value: "nonBinary", label: "Non-Binary" },
  { value: "twoSpirit", label: "Two-Spirit" },
  { value: "preferNotToRespond", label: "Prefer Not to Respond" },
  { value: "other", label: "Other" },
];

export const raceOptions = [
  { value: "caucasian", label: "Caucasian" },
  { value: "black", label: "Black" },
  { value: "Prefernottorespond", label: "Prefer not to respond" },
];

export const characteristicsOptions = [
  { value: "none", header: "None" },
  { value: "dialysis", header: "Dialysis" },
  { value: "gastricBypass", header: "Gastric Bypass" },
  { value: "ostomy", header: "Ostomy" },
  { value: "recentBloodDonation", header: "Recent Blood Donation" },
  { value: "wearsContactLenses", header: "Wears Contact Lenses" },
];

export const medicationAdministrationOptions = [
  { value: "swallowing", label: "Swallowing" },
  { value: "crush Medications", label: "Crush Medications" },
  { value: "liquid Formulations", label: "Liquid Formulations" },
  { value: "ngTube", label: "NG / Feeding Tube" },
];

export const primaryLanguageOptions = [
  { value: "english", label: "English" },
  { value: "french", label: "French" },
  { value: "spanish", label: "Spanish" },
  { value: "chinese", label: "Chinese" },
  { value: "italian", label: "Italian" },
  { value: "other", label: "Other" },
];

export const preferencesOptions = [
  { value: "none", label: "None" },
  { value: "deliverOnly", label: "Deliver Only" },
  { value: "pickUpOnly", label: "Pick-Up Only" },
  { value: "callWhenReady", label: "Call When Ready" },
  { value: "blisterPack", label: "Blister Pack" },
  { value: "useSnapCaps", label: "Snap Caps" },
];

export const statusOptions = [
  { value: "active", label: "Active" },
  { value: "inActive", label: "Inactive" },
];

export const statusWithoutSelectOptions = [
  { value: "active", label: "Active" },
  { value: "inActive", label: "Inactive" },
];

export const patientInactiveStatusOptions = [
  { value: "all", label: "All" },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
  { value: "deceased", label: "Inactive - Deceased" },
  { value: "hospitalized", label: "Inactive - Hospitalized" },
  { value: "outOfProvince", label: "Inactive - Out of Province" },
  { value: "switchedPharmacy", label: "Inactive - Switched Pharmacy" },
  { value: "movedResidence", label: "Inactive - Moved Residence" },
  { value: "unknown", label: "Inactive - Unknown" },
];

export const patientEditStatusOptions = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" }
];

export const patientEditInactiveStatusReasonOptions = [
  { value: "deceased", label: "Deceased" },
  { value: "hospitalized", label: "Hospitalized" },
  { value: "outOfProvince", label: "Out of Province" },
  { value: "switchedPharmacy", label: "Switched Pharmacy" },
  { value: "movedResidence", label: "Moved Residence" },
  { value: "unknown", label: "Unknown" },
];


export const weightDropdownOptions = [
  { value: "kg", label: "kg" },
  { value: "lbs", label: "lbs" },
  { value: "g", label: "g" },
]

export const heightDropdownOptions = [
  { value: "in", label: "in" },
  { value: "cm", label: "cm" }
]

export const stateOptions = [
  { value: "alberta", label: "Alberta" },
  { value: "british_columbia", label: "British Columbia" },
  { value: "manitoba", label: "Manitoba" },
  { value: "new_brunswick", label: "New Brunswick" },
  { value: "newfoundland_and_labrador", label: "Newfoundland and Labrador" },
  { value: "northwest_territories", label: "Northwest Territories" },
  { value: "nova_scotia", label: "Nova Scotia" },
  { value: "nunavut", label: "Nunavut" },
  { value: "ontario", label: "Ontario" },
  { value: "prince_edward_island", label: "Prince Edward Island" },
  { value: "quebec", label: "Quebec" },
  { value: "saskatchewan", label: "Saskatchewan" },
  { value: "yukon", label: "Yukon" },
];

export const countryOptions = [
  { value: "canada", label: "Canada" },
];

export const insurancePlanOptions = [
  { value: "none", label: "None" },
  { value: "assure", label: "Assure (AS)" },
  { value: "claimSecure", label: "Claim Secure (CS)" },
  { value: "expressScripts", label: "Express Scripts (ESI)" },
  { value: "greenShield", label: "Green Shield (GS)" },
  { value: "nextGen", label: "NexGen (NX)" },
  { value: "ontarioBlueCross", label: "Ontario Blue Cross (OB)" },
  { value: "ontarioDrugBenefit", label: "Ontario Drug Benefit (ODB)" },
  { value: "sunlife", label: "Sunlife (SL)" },
  { value: "other", label: "Other" },
];

export const orderOfInsuranceOptions = [
  { value:'none', label: 'None' },
  { value: "primary", label: "Primary" },
  { value: "secondary", label: "Secondary" },
  { value: "tertiary", label: "Tertiary" },
];

export const relationshipTypeOptions = [
  { value: "cardholder", label: "Cardholder" },
  { value: "spouse", label: "Spouse" },
  { value: "child_one", label: "Child One" },
  { value: "child_two", label: "Child Two" },
  { value: "child", label: "Child" }, // You can use "Child" for generic children options
];

export const deductOptions = [
  { value: "dollar", label: "Dollar amount" },
  { value: "percentage", label: "Percentage" },
];

export const phoneOptions = [
  { value: "noPhone", label: "No Phone Information" },
];

export const addressOption = [
  { value: "noAddress", label: "No Permanent Address" },
];
export const longTermOption = [
  { value: "longTermCare", label: "Living in Long Term Care Residence" },
];

export const provincialInsuranceOptions = [
  {
    value: "provincialInsurance",
    label: "Provincial Insurance",
  },
  {
    value: "noInsurancePaymentUnknown",
    label: "No Provincial Insurance on File, Save Patient Only, (Payment Unknown)",
  },
  {
    value: "noInsuranceNoConcent",
    label: "No Provincial Insurance",
    redLabel: "(Patient does not agree to pay for Clinical Service)",
  },
  {
    value: "noInsuranceConcent",
    label:
      "No Provincial Insurance (Patient agrees to pay for Clinical Service)",
  },
];

export const relationshipTypeThirdStepOptions = [
  { value: "spouse", label: "Spouse" },
  { value: "mother", label: "Mother" },
  { value: "father", label: "Father" },
  { value: "son", label: "Son" },
  { value: "daughter", label: "Daughter" },
  { value: "agent", label: "Agent" },
  { value: "lawyer", label: "Lawyer" },
  { value: "other", label: "Other" },
];

export const contactOptions = [
  { value: "primary", label: "Primary Contact" },
  { value: "secondary", label: "Secondary Contact" },
];

export const physicianOptions = [
  { value: "primary", label: "Primary Provider" },
];

export const sameAsPersonalInfoCheckBoxOptions = [
  { value: "sameAsPersonalInfo", label: "Check if same as Patient's address" },
];
export const advanceSearchCheckBoxOptions = [
  { value: "advanceSearch", name: "advanceSearch", label: "Advance Search" },
];

export const designationOptions = [
  { value: "allergist", label: "Allergist/ Immunologist" },
  { value: "cardiologist", label: "Cardiologist" },
  { value: "dermatologist", label: "Dermatologist" },
  { value: "endocrinologist", label: "Endocrinologist" },
  { value: "family_medicine", label: "Family Medicine" },
  { value: "geriatric_medicine", label: "Geriatric Medicine" },
  { value: "nephrologist", label: "Nephrologist" },
  { value: "neurologist", label: "Neurologist" },
  { value: "nurse_practitioner", label: "Nurse Practitioner" },
  { value: "oncologist", label: "Oncologist" },
  { value: "pediatrician", label: "Pediatrician" },
  { value: "psychologist", label: "Psychologist" },
  { value: "psychiatrist", label: "Psychiatrist" },
  { value: "respirologist", label: "Respirologist" },
  { value: "surgeon", label: "Surgeon" },
  { value: "urologist", label: "Urologist" },
  { value: "podiatrist", label: "Podiatrist" },
  { value: "dietitian", label: "Dietitian" },
  { value: "chiropractor", label: "Chiropractor" },
  { value: "physio_therapy", label: "Physio Therapy" },
];

export const thirdPartyInsuranceStatusOptions = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

export const treatmentPlanOptions = [
  { value: 'myResults', label: 'My Results' },
  { value: 'allResults', label: 'All Results' },
]

// Static source options (for AddMedicationDialog and discontinue dialog)
export const sourceOptions = [
  { value: "patient", label: "Patient" },
  { value: "family_caregiver", label: "Family / Caregiver" },
  { value: "pharmacist", label: "Pharmacist" },
  { value: "primary_provider", label: "Primary Provider" },
  { value: "nurse_practitioner", label: "Nurse Practitioner" }
];

// Communication type options (for AddMedicationDialog and discontinue dialog)
export const communicationTypeOptions = [
  { value: "verbal_order", label: "Verbal Order" },
  { value: "phone_order", label: "Phone Order" },
  { value: "written_prescription", label: "Written Prescription" },
  { value: "patient_medication_list", label: "Patient's Medication List" },
  { value: "pharmacy_management_system", label: "Pharmacy Management System" },
  { value: "hospital_discharge_summary", label: "Hospital Discharge Summary/ Rx" },
  { value: "clinical scope", label: "Clinical Scope" }
];

// Static reasons for discontinue
export const reasonOptions = [
  { value: "adverse_reaction", label: "Adverse Reaction" },
  { value: "allergy", label: "Allergy" },
  { value: "cost_concern", label: "Cost Concern" },
  { value: "interaction", label: "Drug Interaction" },
  { value: "ineffective", label: "Ineffective" },
  { value: "patient_request", label: "Patient Request" },
  { value: "provider_recommendation", label: "Provider Recommendation" },
  { value: "other", label: "Other" }
];

export const HistoryTypes = [
  { value: "MedicalCondition", label: "Medical Condition" },
  { value: "MedicalStudy", label: "Medical Study" },
  { value: "MedicalSurgery", label: "Surgery/ Procedure (Past)" },
];
export const SymptomControlOptions = [
  { value: "controlled", label: "Symptoms Controlled" },
  { value: "not controlled", label: "Symptoms Not Controlled" },
  { value: "not sure", label: "Not Sure Symptoms Controlled" },
  { value: "not specified", label: "Not Specified" },
];

export const AllergyValueLabelOptions = [
  { value: "other", label: "Other (Free Text)" },
  { value: "noLongerExists", label: "Allergy No Longer Exists" },
  { value: "duplicateAllergy", label: "Duplicate Allergy" },
  { value: "unspecified ", label: "Unspecified" },
  { value: "wrongDrug", label: "Wrong  Drug" },
];

// Calendar date dropdown options for Medical Conditions, Surgeries, Medical Study, Clinical Alerts, and AMR cards
// These values match the backend DateOption field values
export const CalendarDateOptions = [
  { value: "Date Not Known", label: "Date Not Known" },
  { value: "Date Not Specified", label: "Date Not Specified" },
  { value: "Less than 3 months", label: "Less than 3 months ago" },
  { value: "3 to 6 months", label: "3 to 6 months ago" },
  { value: "6 months to 1 year", label: "6 months to 1 year ago" },
  { value: "Greater than one year", label: "Greater than 1 year ago" },
  { value: "(YYYY)", label: "YYYY - Year only" },
  { value: "(MM/YYYY)", label: "MM/YYYY - Month, Year" },
  { value: "(DD/MM/YYYY)", label: "Select Date - DD/MM/YYYY" },
];

